<template>
  <div class="p-0 m-auto" ref="container">
    <canvas :width="width" :height="height" ref="canvas"></canvas>
  </div>
</template>
<script>
import Konva from 'konva'

export default {
  name: 'ImageDrawCanvas',
  props: {
    'memoBackGroundImage': String,
    'memoBackGroundImageWidth': Number,
    'memoBackGroundImageHeight': Number,
    'drawMode': String,
    'penColor': String,
    'lineWidth': String
  },
  data: () => ({
    width: 200,
    height: 200,
    stage: null,
    canvas: null,
    context: null,
    drawingLayer: null,
    drawingScope: null,
    lastPointerPosition: {},
    localPos: {
      x: 0,
      y: 0
    },
    pos: null,
    isPaint: false,
    imageObj: null,
    backgroundLayer: null,
    backgroundImageScope: null
  }),
  mounted: function () {
    var container = this.$refs.container
    this.stage = new Konva.Stage({
      container,
      width: this.width,
      height: this.height
    })
    this.drawingLayer = new Konva.Layer()
    this.stage.add(this.drawingLayer)

    this.canvas = this.$refs.canvas
    this.drawingScope = new Konva.Image({
      image: this.canvas,
      x: 0,
      y: 0,
      stroke: ''
    })
    this.drawingLayer.add(this.drawingScope)
    this.stage.draw()

    this.context = this.canvas.getContext('2d')
    this.context.globalCompositeOperation = this.drawMode
    this.context.strokeStyle = this.penColor
    this.context.lineWidth = Number(this.lineWidth)
    this.context.lineJoin = 'round'

    this.drawingScope.on('mousedown', this.mousedown)
    this.stage.addEventListener('mouseup', this.mouseup)
    this.stage.addEventListener('mousemove', this.mousemove)
    this.drawingScope.on('touchstart', this.mousedown)
    this.stage.addEventListener('touchend', this.mouseup)
    this.stage.addEventListener('touchmove', this.mousemove)
  },
  watch: {
    memoBackGroundImage: function (newData, oldData) {
      // 手描き画像変更時
      this.onClearCanvas()
      this.stage.removeChildren()
      this.imageObj = new Image()
      // this.imageObj.crossOrigin = 'Anonymous'
      this.imageObj.src = newData

      const imageObj = this.imageObj
      imageObj.onload = (e) => {
        this.imageOnload()
        this.stage.draw()
      }
    },
    drawMode: function () {
      // モード変更時
      this.context.globalCompositeOperation = this.drawMode
      this.context.lineWidth = Number(this.lineWidth)
    },
    penColor: function () {
      // ペンカラー変更時
      this.context.strokeStyle = this.penColor
    },
    lineWidth: function () {
      // ペン太さ変更時
      this.context.lineWidth = Number(this.lineWidth)
    }
  },
  methods: {
    mousedown: function () {
      this.isPaint = true

      // マウスダウン時の座標を取得しておく
      this.lastPointerPosition = this.stage.getPointerPosition()
    },
    mouseup: function () {
      this.isPaint = false
    },
    mousemove: function () {
      if (!this.isPaint) {
        return
      }
      // 描画処理
      this.drawing(this.stage.getPointerPosition())
    },
    drawing (pointerPosition) {
      this.context.beginPath()
      this.localPos.x = this.lastPointerPosition.x - this.drawingScope.x()
      this.localPos.y = this.lastPointerPosition.y - this.drawingScope.y()

      // 描画開始座標を指定する
      this.context.moveTo(this.localPos.x, this.localPos.y)

      this.pos = pointerPosition
      this.localPos.x = this.pos.x - this.drawingScope.x()
      this.localPos.y = this.pos.y - this.drawingScope.y()

      // 描画開始座標から、lineToに指定された座標まで描画する
      this.context.lineTo(this.localPos.x, this.localPos.y)
      this.context.closePath()
      this.context.stroke()
      this.drawingLayer.draw()

      this.lastPointerPosition = this.pos
    },
    onClearCanvas: function () {
      this.context.globalCompositeOperation = 'destination-out'
      this.context.fillRect(0, 0, this.width, this.height)
      this.drawingLayer.draw()
    },
    onExportDrawnImage: function () {
      this.$emit('registDrawnImage', this.stage.toDataURL())
    },
    onExportProductionDrawnImage: function () {
      this.$emit('registProductionDrawnImage', this.stage.toDataURL())
    },
    calculateWidth () {
      const computedStyle = window.getComputedStyle(document.getElementById('content-area-inner'))
      this.width = document.getElementById('content-area-inner').clientWidth - (parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight))
      window.innerWidth >= 992 ? this.stage.width((this.width / 12) * 9) : this.stage.width(this.width)
    },
    clearCanvas: function () {
      this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.drawingLayer.draw()
    },
    imageOnload: function () {
      // 背景画像設定＆表示位置調整
      this.backgroundLayer = new Konva.Layer()
      this.canvas.width = this.memoBackGroundImageWidth
      this.canvas.height = this.memoBackGroundImageHeight
      this.stage.width(this.canvas.width)
      this.stage.height(this.canvas.height)
      this.stage.add(this.drawingLayer)

      this.backgroundImageScope = new Konva.Image({
        image: this.imageObj,
        x: 0,
        y: 0,
        width: this.canvas.width,
        height: this.canvas.height
      })

      this.backgroundLayer.add(this.backgroundImageScope)
      this.stage.add(this.backgroundLayer)
      this.backgroundLayer.moveToBottom()

      this.context.globalCompositeOperation = this.drawMode
      this.context.strokeStyle = this.penColor
      this.context.lineWidth = Number(this.lineWidth)
      this.context.lineJoin = 'round'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ImageDrawCanvas.vue